import { IS_LOADING, ERROR} from "../../constants";

export { IS_LOADING, ERROR }

export const GET_WEEK_REPORT = 'GET_WEEK_REPORT';
export const ADD_WEEK_REPORT = 'ADD_WEEK_REPORT';
export const DELETE_ALL_REPORT = 'DELETE_ALL_REPORT';

export const SYNCHRO_GET_API_REPORT = 'SYNCHRO_GET_API_REPORT';
